export default "__VITE_ASSET__d67DP60U__"